<template>
    <a @click="initMatific()" :class="classes" v-if="hasMatific">
        <slot name="content" />
    </a>
</template>
<script>
import axios from 'axios';
export default {
    name: 'MatificButton',
    props: {
        classes: String,
    },
    data() {
        return {
			matificSchools: [417, 380, 416, 420, 421, 457, 330, 340, 460, 6, 459, 382, 329]
        }
    },
    methods: {
        async initMatific() {
            let personId = this.$store.state.session.currentUser.personId;
            try {
                const tokenResponse = await axios.post(`${process.env.VUE_APP_API_URL}/matific/temp-token/${personId}`, {
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.$store.state.session.token }
                })
                const token = tokenResponse.data.token
                const matificUrl = `https://www.matific.com/api/v2/integrations/login?vendor_id=${process.env.VUE_APP_MATIFIC_VENDOR_ID}&vendor_token=${token}`;
                window.open(matificUrl, '_blank');
            } catch (error) {
                console.error(error);
            }
        },
    },
    computed: {
        hasMatific: function() {
            const userSchoolId = this.$store.state.session.currentUser.roles[0].schoolId;
            return this.matificSchools.includes(userSchoolId);
        },
    }
}
</script>